// 登录规则
const validateName = (rule, value, callback) => {
  if (!value) {
    return callback(new Error("用户名不能为空"));
  } else {
    callback();
  }
};

export const validatePassword = (rule, value, callback) => {
  if (value === "") {
    callback(new Error("密码不能为空"));
  } else {
    callback();
  }
};

export const SignInRules = {
  username: [{ validator: validateName, trigger: "blur"}],
  password: [{ validator: validatePassword, trigger: "blur"}],
  captcha: [
      { required: true, trigger: "blur",message: '请输入验证码'},
      { max: 6, message: '长度不能超过6个字符' },
      { min: 6, message: '长度不能低于6个字符' },
  ],
};

// 注册规则
export const SignUpRules = {
  username: [{ required: true, message: "请输入用户名", trigger: "blur", min: 3 }],
  password: [{ required: true, message: "请输入密码", trigger: "blur", min: 3 }],
  confirmPassword: [{ required: true, message: "请输入确认密码", trigger: "blur", min: 3 } ],
  sex: [{ required: true, message: "请选择性别", trigger: "change" }],
  phoneNum: [
      { required: true,message: "请输入手机号", trigger: "blur" },
      { pattern: /^1[3-9]\d{9}$/, message: "请输入正确的手机号格式", trigger: "blur" }],
  email: [
    { message: "请输入邮箱地址", trigger: "blur" },
    {
      type: "email",
      message: "请输入正确的邮箱地址",
      trigger: ["blur", "change"],
    },
  ],
  // birth: [{ required: true, type: "date", message: "请选择日期", trigger: "change" }],
  introduction: [{ message: "请输入介绍", trigger: "blur" }],
  location: [{ message: "请输入地区", trigger: "change" }],
};
